export default class MapeadorCamposTexto {
    processar({ campo, atribuicoes, dadoCampo }) {
        if (campo.mapeamento) {
            atribuicoes[campo.mapeamento] = dadoCampo;
        }
    }
}
